import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import * as generic from '../../../components/Generico';
import { AccionistaService } from '../../../service/AccionistaService';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { AccionistaPep as AccionistaPepModel } from '../../../models/ficha/AccionistaPep';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';
import { PepAfinidad } from '../common/PepAfinidad';

export const Pep = ({ toast, back, next, id, permss, soloLectura, catalogos }) => {

    const omodel = new AccionistaPepModel({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues });
    const accionistaServ = new AccionistaService();
    const { inText, inCalendar, inDrop } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [esPep, setEsPep] = useState(false);
    const [esVinculoPep, setEsVinculoPep] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        editarFicha();
        // eslint-disable-next-line
    }, [id]);

    const editarFicha = () => {
        if (id == null) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        accionistaServ.consultarAccionista(id, 'seccion3').then(res => {
            if (!res.data.accionista) {
                return;
            }
            const _accionista = res.data.accionista;
            setEsPep(_accionista.pep?.cat_id);
            setEsVinculoPep(_accionista.esta_relacionado_pep?.cat_id);
            if (_accionista.pep) {
                if (_accionista.fecha_dejo_pep) {
                    _accionista.fecha_dejo_pep = generic.stringToDate(_accionista.fecha_dejo_pep);
                }
                _accionista.fecha_nombramiento_pep = generic.stringToDate(_accionista.fecha_nombramiento_pep);
            }
            if (_accionista.esta_relacionado_pep) {
                _accionista.fecha_vinculo_pep = generic.stringToDate(_accionista.fecha_vinculo_pep);
                if (_accionista.fecha_culminacion_pep) {
                    _accionista.fecha_culminacion_pep = generic.stringToDate(_accionista.fecha_culminacion_pep);
                }
            }

            reset(generic.renewValues(_accionista, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        setIsSaving(true);
        data.id = id;
        data.seccion = 'seccion3';
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;
        if (esPep) {
            data.fecha_nombramiento_pep = generic.dateToString(data.fecha_nombramiento_pep);
            if (data.fecha_dejo_pep) {
                data.fecha_dejo_pep = generic.dateToString(data.fecha_dejo_pep);
            }
        } else {
            delete data.fecha_nombramiento_pep;
            delete data.fecha_dejo_pep;
        }
        if (esVinculoPep) {
            data.fecha_vinculo_pep = generic.dateToString(data.fecha_vinculo_pep);
            if (data.fecha_culminacion_pep) {
                data.fecha_culminacion_pep = generic.dateToString(data.fecha_culminacion_pep);
            }
        } else {
            delete data.fecha_vinculo_pep;
            delete data.fecha_culminacion_pep;
        }
        accionistaServ.editarAccionista(data).then(res => {
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangePep = (e, esCampoPep) => {
        if (esCampoPep) {
            setEsPep(e.value?.cat_id);
            setValue('nombre_pep', '');
            setValue('cargo_pep', '');
            setValue('institucion_trabaja_pep', '');
            setValue('fecha_nombramiento_pep', null);
            setValue('fecha_dejo_pep', null);
        } else {
            setEsVinculoPep(e.value?.cat_id);
            setValue('relacion_vinculo_pep', '');
            setValue('nombre_vinculo_pep', '');
            setValue('cargo_vinculo_pep', '');
            setValue('institucion_vinculo_pep', '');
            setValue('fecha_vinculo_pep', null);
            setValue('fecha_culminacion_pep', null);
        }
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form id="pepAccionistaForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
            <Panel header={generic.renderPanelHeader('5', 'PERSONA EXPUESTA POLÍTICAMENTE (PEP) - DESCRIBIR EN EL CASO QUE SOCIOS, ACCIONISTAS O DIRECTIVOS OCUPEN ESTOS CARGOS', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-4">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Definición de PEP</span>
                    </div>
                    {omodel.strPep}
                </div>

                <div className="col-12 mb-3 mt-3">
                    <div className="flex align-items-center">
                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                            <i className="pi pi-user text-primary"></i>
                            CONDICIÓN DE PEP
                        </span>
                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                    </div>
                </div>

                <div className="formgrid grid mb-4">
                    {inDrop('pep', generic.estadosSiNo, { lab: omodel.optionLabel, chn: onChangePep, val: true }, 12)}
                    {esPep && (
                        <>
                            {inText('nombre_pep', { icon: 'pi pi-user' }, 6)}
                            {inText('cargo_pep', { icon: 'pi pi-briefcase' }, 6)}
                            {inText('institucion_trabaja_pep', { icon: 'pi pi-building' }, 12)}
                            {inCalendar('fecha_nombramiento_pep', {}, 6)}
                            {inCalendar('fecha_dejo_pep', { obl: true }, 6)}
                        </>
                    )}
                </div>

                <div className="col-12 mb-3">
                    <div className="flex align-items-center">
                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                            <i className="pi pi-users text-primary"></i>
                            FAMILIARES O RELACIONADOS
                        </span>
                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                    </div>
                </div>

                <div className="col-12 px-0 mb-4">
                    <PepAfinidad tipo='accionistaPn' id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                </div>

                <div className="col-12 mt-3 mb-3">
                    <div className="flex align-items-center">
                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                            <i className="pi pi-share-alt text-primary"></i>
                            VÍNCULO CON UN PEP
                        </span>
                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                    </div>
                </div>

                <div className="formgrid grid">
                    {inDrop('esta_relacionado_pep', generic.estadosSiNo, { lab: omodel.optionLabel, chn: onChangePep, val: false }, 12)}
                    {esVinculoPep && (
                        <>
                            {inText('relacion_vinculo_pep', { icon: 'pi pi-link' }, 6)}
                            {inText('nombre_vinculo_pep', { icon: 'pi pi-user' }, 6)}
                            {inText('cargo_vinculo_pep', { icon: 'pi pi-briefcase' }, 6)}
                            {inText('institucion_vinculo_pep', { icon: 'pi pi-building' }, 6)}
                            {inCalendar('fecha_vinculo_pep', {}, 6)}
                            {inCalendar('fecha_culminacion_pep', {}, 6)}
                        </>
                    )}
                </div>
            </Panel>

            <BottomActionBar onPrev={back} onNext={next} formId="pepAccionistaForm" loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}
